import { action } from 'typesafe-actions'
import { ActionTypes } from './constants'
import type {
  AddedGroup,
  AddedGroups,
  AddedMaterial,
  AddedMaterials,
  Crew,
  MaterialAssembly,
  MaterialPricing,
  ProjectMaterials,
  TakeoffQuantities,
} from './types'

export const getMaterialPricingSuccess = (materialPricing: ProjectMaterials) => {
  return action(ActionTypes.GET_MATERIAL_PRICING, {
    materialPricing,
  })
}

export const materialPricingAddedSuccess = (materialPricing: MaterialPricing) => {
  return action(ActionTypes.MATERIAL_PRICING_ADDED, {
    materialPricing,
  })
}

export const getMaterialsSuccess = (materials: AddedMaterials) => {
  return action(ActionTypes.GET_MATERIALS, {
    materials,
  })
}

export const editMaterialsSuccess = (material: AddedMaterial) => {
  return action(ActionTypes.EDIT_MATERIAL, {
    material,
  })
}

export const postMaterialsSuccess = (material: AddedMaterial) => {
  return action(ActionTypes.POST_MATERIAL, {
    material,
  })
}

export const deleteMaterialsSuccess = (materialId: AddedMaterial['id']) => {
  return action(ActionTypes.DELETE_MATERIAL, {
    materialId,
  })
}

export const getProjectMaterialsSuccess = (materials: ProjectMaterials) => {
  return action(ActionTypes.GET_PROJECT_MATERIALS, {
    materials,
  })
}

export const editProjectMaterialSuccess = (material: AddedMaterial) => {
  return action(ActionTypes.EDIT_PROJECT_MATERIAL, {
    material,
  })
}

export const deleteProjectMaterialSuccess = (materialId: AddedMaterial['id']) => {
  return action(ActionTypes.DELETE_PROJECT_MATERIAL, {
    materialId,
  })
}

export const getMaterialsGroupsSuccess = (groups: AddedGroups) => {
  return action(ActionTypes.GET_MATERIALS_GROUPS, {
    groups,
  })
}

export const addMaterialsGroupSuccess = (group: AddedGroup) => {
  return action(ActionTypes.POST_MATERIALS_GROUP, {
    group,
  })
}

export const editMaterialsGroupSuccess = (group: AddedGroup) => {
  return action(ActionTypes.EDIT_MATERIALS_GROUP, {
    group,
  })
}

export const getMaterialGroups = (materialId: AddedMaterial['id']) => {
  return action(ActionTypes.GET_MATERIAL_GROUPS, {
    materialId,
  })
}

export const getMaterialAssembliesSuccess = (materialAssemblies: MaterialAssembly[]) => {
  return action(ActionTypes.GET_MATERIAL_ASSEMBLIES, {
    materialAssemblies,
  })
}
export const getProjectMaterialAssembliesSuccess = (projectMaterialAssemblies: ProjectMaterials) => {
  console.log('Action: GET_PROJECT_MATERIAL_ASSEMBLIES', projectMaterialAssemblies)
  return action(ActionTypes.GET_PROJECT_MATERIAL_ASSEMBLIES, {
    projectMaterialAssemblies,
  })
}

export const postMaterialAssemblySuccess = (assembly: MaterialAssembly) => {
  return action(ActionTypes.POST_MATERIAL_ASSEMBLY, {
    assembly,
  })
}

export const editMaterialAssemblySuccess = (assembly: MaterialAssembly) => {
  return action(ActionTypes.EDIT_MATERIAL_ASSEMBLY, {
    assembly,
  })
}

export const deleteMaterialAssemblySuccess = (assemblyId: MaterialAssembly['id']) => {
  return action(ActionTypes.DELETE_MATERIAL_ASSEMBLY, {
    assemblyId,
  })
}

export const getProjectTakeOffQuantitiesSuccess = (takeoffQuantities: TakeoffQuantities) => {
  return action(ActionTypes.GET_PROJECT_TAKEOFF_QUANTITIES, {
    takeoffQuantities,
  })
}

export const getMaterialPricingsSuccess = (materialPricings: MaterialPricings) => {
  return action(ActionTypes.GET_MATERIAL_PRICINGS, {
    materialPricings,
  })
}

export const postMaterialPricingSuccess = (materialPricing: MaterialPricing) => {
  return action(ActionTypes.POST_MATERIAL_PRICING, {
    materialPricing,
  })
}

export const editMaterialPricingSuccess = (materialPricing: MaterialPricing) => {
  return action(ActionTypes.EDIT_MATERIAL_PRICING, {
    materialPricing,
  })
}

export const deleteMaterialPricingSuccess = (materialPricingId: MaterialPricing['id']) => {
  return action(ActionTypes.DELETE_MATERIAL_PRICING, {
    materialPricingId,
  })
}

export const getCrewsSuccess = (crews: Crew[]) => {
  return action(ActionTypes.GET_CREWS, {
    crews,
  })
}

export const postCrewSuccess = (crew: Crew) => {
  return action(ActionTypes.POST_CREW, {
    crew,
  })
}

export const editCrewSuccess = (crew: Crew) => {
  return action(ActionTypes.EDIT_CREW, {
    crew,
  })
}

export const deleteCrewSuccess = (crewId: string) => {
  return action(ActionTypes.DELETE_CREW, {
    crewId,
  })
}
